

import { createSlice } from "@reduxjs/toolkit";
import { IOrderItems } from "../interface/IOrderItem";

const initialState: IOrderItems[] | null = null;

const deleteItemsSlice = createSlice({
    name: "deleteItems",
    initialState,
    reducers: {
        setDeleteItemsStore: (state, action) => {
            return action.payload;
        },
    },
});

export const { setDeleteItemsStore } = deleteItemsSlice.actions

export default deleteItemsSlice.reducer;
